var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"vue-add-to-cart"},[_c('button',{staticClass:"btn-primary add-to-cart",attrs:{"disabled":_setup.isLoading},on:{"click":_setup.handleAddToCart}},[_vm._v("\n    "+_vm._s(_setup.addToCartText)+"\n    "),(_setup.isLoading)?[_c('dentaid-loader')]:_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }